import { render, staticRenderFns } from "./userChgCardPay.vue?vue&type=template&id=b24e5e9c&scoped=true&"
import script from "./userChgCardPay.vue?vue&type=script&lang=js&"
export * from "./userChgCardPay.vue?vue&type=script&lang=js&"
import style0 from "./userChgCardPay.vue?vue&type=style&index=0&id=b24e5e9c&lang=less&scoped=true&"
import style1 from "./userChgCardPay.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24e5e9c",
  null
  
)

export default component.exports